var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1471 18.3541C19.2024 18.4056 19.2467 18.4677 19.2775 18.5367C19.3082 18.6057 19.3248 18.6802 19.3261 18.7557C19.3274 18.8312 19.3135 18.9063 19.2852 18.9763C19.2569 19.0463 19.2148 19.11 19.1614 19.1634C19.108 19.2168 19.0444 19.2589 18.9743 19.2872C18.9043 19.3155 18.8293 19.3294 18.7537 19.328C18.6782 19.3267 18.6037 19.3102 18.5347 19.2794C18.4657 19.2487 18.4036 19.2044 18.3521 19.1491L11.9996 12.7975L5.64714 19.1491C5.54051 19.2485 5.39947 19.3025 5.25375 19.3C5.10802 19.2974 4.96898 19.2384 4.86592 19.1353C4.76286 19.0323 4.70383 18.8932 4.70126 18.7475C4.69869 18.6018 4.75278 18.4607 4.85214 18.3541L11.2037 12.0016L4.85214 5.64909C4.75278 5.54246 4.69869 5.40143 4.70126 5.2557C4.70383 5.10998 4.76286 4.97094 4.86592 4.86788C4.96898 4.76482 5.10802 4.70578 5.25375 4.70321C5.39947 4.70064 5.54051 4.75473 5.64714 4.85409L11.9996 11.2057L18.3521 4.85409C18.4588 4.75473 18.5998 4.70064 18.7455 4.70321C18.8913 4.70578 19.0303 4.76482 19.1334 4.86788C19.2364 4.97094 19.2955 5.10998 19.298 5.2557C19.3006 5.40143 19.2465 5.54246 19.1471 5.64909L12.7956 12.0016L19.1471 18.3541Z",
    fill: "#404D6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.80d28704c3ff9ccb2c0391e5456e90c1.svg";
export { ForwardRef as ReactComponent };